export default __webpack_public_path__ + "static/media/vm-mic-fill.a924b41b.svg";